// src/utils/googleMaps.js
const API_KEY = "AIzaSyC4HEFByfCaTKqLWZpGA6ov2HzRryUaUlI";
const CALLBACK_NAME = "gmapsCallback";

let loaderPromise = null;

export const loadGoogleMaps = () => {
  if (loaderPromise) return loaderPromise;

  loaderPromise = new Promise((resolve, reject) => {
    // 1. Check if Google Maps is already fully loaded and Modern (has importLibrary)
    if (window.google && window.google.maps && typeof window.google.maps.importLibrary === 'function') {
      resolve(window.google.maps);
      return;
    }

    // 2. DETECT ZOMBIE SCRIPT: If maps exists but is OLD (no importLibrary), nuke it.
    if (window.google && window.google.maps && typeof window.google.maps.importLibrary !== 'function') {
        console.warn("Legacy Google Maps detected. Forcing reload of Modern API...");
        delete window.google.maps;
        delete window.google;
        const scripts = document.querySelectorAll('script[src*="maps.googleapis.com"]');
        scripts.forEach(s => s.remove());
    }

    // 3. Check if script is currently loading
    const existingScript = document.getElementById('google-maps-script');
    if (existingScript) {
        // Hook into the global callback if it exists, or poll for it
        const originalCallback = window[CALLBACK_NAME];
        window[CALLBACK_NAME] = () => {
            if (originalCallback) originalCallback();
            resolve(window.google.maps);
        };
        return;
    }

    // 4. Load Fresh Script
    window[CALLBACK_NAME] = () => {
        if (window.google && window.google.maps) {
            resolve(window.google.maps);
        } else {
            reject(new Error("Google Maps loaded but namespace is missing."));
        }
    };

    const script = document.createElement("script");
    script.id = 'google-maps-script';
    // libraries=marker is required for AdvancedMarkerElement
    script.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&callback=${CALLBACK_NAME}&libraries=places,marker&v=weekly&loading=async`;
    script.async = true;
    script.defer = true;
    script.onerror = (error) => {
      loaderPromise = null; // Reset promise to allow retry
      reject(error);
    };
    document.head.appendChild(script);
  });

  return loaderPromise;
};